/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef, HTMLAttributes } from 'react';
import { FaqMain } from 'types/puppyGuide';
import './faq-stack.scss';
import { KibAccordionNew, KibAccordionNewItem } from '@chewy/kib-content-groups-react';
import '@chewy/kib-content-groups-styles/dist/styles/kib-accordion-new.css';
import { ANALYTICS_ACTION_EXPAND } from '../../AnalyticsProvider';

interface FAQStackProps extends HTMLAttributes<HTMLElement> {
  faq: FaqMain;
  sectionNumber: number;
  recordAnalytics: (analyticsEvent: string, analyticsLabel: string) => void;
}

const FAQStack = forwardRef<HTMLDivElement, FAQStackProps>(
  ({ faq, sectionNumber, recordAnalytics, ...props }, ref) => (
    <div
      className="puppy-guide-faq-stack starter-guide-container"
      data-testid={`puppy-guide-section-${sectionNumber}-faq`}
      id={`section-${sectionNumber}-faq`}
      ref={ref}
      {...props}
    >
      <div className="puppy-guide-faq-stack__content">
        <h3 className="starter-guide-section-header">{faq.title}</h3>
        <KibAccordionNew
          className="puppy-guide-faq-stack__details"
          data-testid="puppy-guide-faq-block"
        >
          {faq.faqs.map((fq, faqsIndex) => (
            <KibAccordionNewItem
              key={faqsIndex}
              title={fq.title}
              onToggle={() => {
                recordAnalytics(ANALYTICS_ACTION_EXPAND, fq.title);
              }}
              data-testid="puppy-guide-faq-item"
            >
              {fq.answer}
            </KibAccordionNewItem>
          ))}
        </KibAccordionNew>
      </div>
    </div>
  ),
);

FAQStack.displayName = 'FAQStack';

export default FAQStack;
